import { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'

import styles from './styles.module.scss'

import { Loader } from '@/components/Loader'
import { StorageService } from '@/services/storage'
import { useDownload } from '@/pages/@hooks/use-download'

const storageService = new StorageService()

export const OpenDocument = () => {
  const { filename } = useParams()
  const { download, errorDownload, url } = useDownload({
    storageService,
  })

  useEffect(() => {
    download(filename)
  }, [])

  if (errorDownload) {
    toast('Ocorreu algum erro, tente novamente.')
    return
  }

  return (
    <div className={styles.document}>
      {url && <iframe src={url} />}
      {!url && <Loader />}
    </div>
  )
}
